import { observer } from 'mobx-react';
import { useStores } from '../stores/RootStore';
import React from 'react';
function FieldHelper(props) {
    const { field, children } = props;
    const { translateStore: { translate } } = useStores();
    const { isTouched, isMissing, hasError, description } = field;
    const errorMessage = React.useMemo(() => {
        if (isTouched) {
            if (isMissing) {
                return translate('field.mandatory');
            }
            else if (hasError) {
                return translate('field.defaultError');
            }
        }
    }, [isTouched, isMissing, hasError, translate]);
    return children({ errorMessage, helpMessage: description });
}
export default observer(FieldHelper);
//# sourceMappingURL=FieldHelper.js.map